{
  "assignments": {
    "withdraw": {
      "action": "Can't serve as a judge? Withdraw from this competition",
      "dialogTitle": "Withdraw from judging this competition",
      "dialogTarget": "{{count}} submissions without a submitted score",
      "dialogScope": "Cancels all of your assignments in this competition that have no submitted score; submitted scores are not affected.",
      "dialogImpact": "You cannot undo this yourself, the organizer must reassign; your reason is recorded and visible to the organizer.",
      "dialogConfirm": "Confirm withdrawal",
      "dialogSuccessLeft": "You have withdrawn and given up the judge role in this competition; the organizer must invite you again if you want to serve later.",
      "leaveRole": "Also give up my judge role in this competition (the organizer must invite me again)",
      "dialogSuccess": "You have withdrawn from judging this competition; the organizer will rearrange the work."
    },
    "links": {
      "profile": "My judge profile",
      "history": "Score history"
    },
    "announcements": {
      "title": "Announcements"
    },
    "progress": {
      "label": "{{done}} / {{total}} completed",
      "aria": "Overall judging progress"
    },
    "title": "Judge assignments",
    "description": "Assigned work is identified anonymously. Other judges’ scores and rankings are never shown here.",
    "loading": "Loading assignments…",
    "noCompetition": "Select a competition to view your judging assignments.",
    "competitionLabel": "Competition",
    "selectCompetitionPlaceholder": "Select a competition…",
    "empty": "No assignments yet.",
    "error": "Could not load your assignments.",
    "noJudgeCompetitions": "You are not assigned as a judge on any competition yet.",
    "accessDenied": {
      "title": "You can't access this competition's judging workspace",
      "description": "You are not currently able to enter this competition in this role.",
      "back": "Back to judging assignments"
    },
    "roundsTablist": "Rounds",
    "workTitle": "Submission {{code}}",
    "round": "Round: {{name}}",
    "rubricVersion": "Rubric: {{name}}",
    "currentTotal": "Current total {{total}} / 100 (only visible to you)",
    "savedAt": "Draft · saved {{time}}",
    "competitionOptionPending": "{{count}} pending",
    "statusBadge": {
      "not_started": "Not started",
      "draft": "Draft",
      "submitted": "Submitted"
    },
    "cta": {
      "start": "Start scoring",
      "continue": "Continue scoring",
      "view": "View score"
    },
    "summary": {
      "pending": "{{count}} pending",
      "draft": "{{count}} draft",
      "submitted": "{{count}} submitted"
    },
    "filters": {
      "label": "Filter by status",
      "all": "All",
      "pending": "Pending",
      "draft": "Draft",
      "submitted": "Submitted"
    },
    "conflict": {
      "declareAction": "Declare conflict of interest",
      "declaredBadge": "Conflict declared",
      "blockedFromScoring": "You can no longer score this submission.",
      "dialogTitle": "Declare conflict of interest",
      "dialogScope": "This assignment only",
      "dialogImpact": "You will immediately lose the ability to score this submission, and the organizer will be notified to reassign a judge.",
      "dialogConfirm": "Declare conflict",
      "dialogSuccess": "Conflict of interest declared. You can no longer score this submission."
    },
    "noScoringNeeded": {
      "badge": "No scoring needed"
    }
  },
  "terms": {
    "title": "Judging terms and confidentiality",
    "intro": "Before you start, please confirm you understand and agree to the rules below. You only need to do this once per competition.",
    "rules": {
      "confidentiality": {
        "title": "Confidentiality",
        "body": "Submissions and any information about participants are for this judging only. Do not download, forward, publicly share, or use them for anything other than scoring."
      },
      "conflict": {
        "title": "Conflict of interest",
        "body": "If you have a relationship with the participants that could affect fairness (mentoring, family, employment), declare a conflict from your assignments first and do not score that submission."
      },
      "anonymity": {
        "title": "Anonymity and fairness",
        "body": "Submissions are shown by anonymous code; do not try to identify participants. External links and videos are controlled by the team, so consider opening them in a private window."
      },
      "scoring": {
        "title": "How scoring works",
        "body": "Score each rubric criterion; drafts are saved automatically. Final submit locks the score, and changes after that go through the organizer."
      },
      "deadline": {
        "title": "Deadline",
        "body": "Please finish all scoring before the judging deadline; the time left is shown on your assignments page."
      }
    },
    "guideHint": "Full details are in the",
    "guideLink": "Judge Guide",
    "agree": "I have read and agree to follow the confidentiality and conflict-of-interest rules above",
    "confirm": "Confirm and start judging",
    "error": "We could not record your confirmation. Please try again.",
    "scoreBlocked": "Please confirm the judging terms on your assignments page before scoring.",
    "scoreBlockedLink": "Go to my assignments"
  },
  "profile": {
    "title_page": "My judge profile",
    "description": "This is shown to this competition's organizers (judge list), never to participants or other judges. It is saved per competition.",
    "identityNote": "Change your name and email under \"Account & security\" in the account menu.",
    "organization": "Organization",
    "title": "Title",
    "expertise": "Expertise (comma separated)",
    "bio": "Bio",
    "save": "Save",
    "saved": "Saved.",
    "error": "Could not save. Please check the fields and try again.",
    "unavailable": "Your judge profile is not available right now."
  },
  "history": {
    "title": "Score history",
    "description": "Everything you have submitted across competitions. Drafts and not-started work are on your assignments page.",
    "submittedOf": "{{done}} of {{total}} submitted",
    "average": "Average total {{value}}",
    "none": "No score submitted yet",
    "view": "View"
  },
  "deadline": {
    "label": "Judging deadline: {{time}}",
    "remaining": "{{amount}} left",
    "overdueBy": "{{amount}} overdue. Please finish soon and contact the organizer",
    "overdueBadge": "Overdue",
    "daysHours": "{{days}}d {{hours}}h",
    "hours": "{{hours}}h",
    "underOneHour": "under 1 hour"
  },
  "score": {
    "loading": "Loading review…",
    "description": "Score draft data is private to you. Submission permanently locks this score.",
    "titleShort": "Submission {{code}}",
    "rubric": "Rubric",
    "rubricDescription": {
      "show": "Show scoring guidance",
      "hide": "Hide scoring guidance"
    },
    "currentTotal": "Current total {{total}} / 100",
    "completion": "{{done}} / {{total}} criteria completed",
    "overallComments": "Personal review note",
    "commentNote": "Only you can see this — it is never shown to other judges or contestants.",
    "reviewComment": "Review comment",
    "reviewCommentNote": "Visible to you and the competition organizer — never to other judges or contestants.",
    "reviewCommentRequiredMark": "(required)",
    "reviewCommentRequiredError": "This competition requires a review comment before you can submit a score.",
    "saveDraft": "Save draft",
    "submitScore": "Submit score",
    "submitConfirm": "Submit and lock this score?",
    "back": "Back to assignments",
    "files": "Submission files",
    "tabFiles": "Slides & files",
    "tabVideo": "Video",
    "workViewLabel": "Work view",
    "links": "Submitted links",
    "workNavLabel": "Switch submission",
    "previous": "Previous",
    "nextInOrder": "Next",
    "position": "{{index}} of {{total}}",
    "shortcutsHint": "Shortcuts: Ctrl/⌘+S save draft · Ctrl/⌘+Enter submit · Alt+←/→ previous/next. Drafts are also saved automatically after you stop typing.",
    "externalNotice": "These are external links controlled by the team; availability may change. To protect anonymous judging, consider opening them in a private window.",
    "externalHost": "External link · {{host}}",
    "noFiles": "No files uploaded for this submission yet.",
    "saveSuccess": "Draft saved.",
    "submitSuccess": "Score submitted and locked.",
    "saveError": "Save failed, please check the scores and retry.",
    "submitError": "Submit failed, please check the scores and retry.",
    "scoreOutOfRange": "\"{{name}}\" score must be between {{min}} and {{max}}.",
    "state": {
      "unsaved": "Draft · unsaved",
      "saving": "Saving…",
      "savedAt": "Draft · saved at {{time}}",
      "submitted": "Submitted · {{time}}"
    },
    "completionGate": {
      "complete": "✓ All required scores are complete",
      "incomplete": "{{count}} required score(s) still missing",
      "reviewCommentMissing": "Review comment still required"
    },
    "reviewMode": {
      "title": "Score locked",
      "totalLabel": "Total",
      "finalTotal": "Final total {{total}} / 100",
      "scoresCompleted": "{{count}} score(s) completed",
      "completedHeading": "✓ This review is complete"
    },
    "weightedContribution": "Weighted {{value}}",
    "anonymousTag": "Anonymous code {{code}}",
    "nextAssignment": "Next pending submission",
    "nextAssignmentNone": "No other pending submissions right now",
    "confirmDialog": {
      "title": "Confirm score submission",
      "description": "Submitting permanently locks this score — you will not be able to change the scores or comment yourself afterward.",
      "totalLabel": "Current total",
      "commentBlankWarning": "The comment is still blank.",
      "commentStatus": {
        "blank": "Comment: not filled in",
        "filled": "Comment: filled in"
      },
      "reviewCommentStatus": {
        "blank": "Review comment: not filled in",
        "filled": "Review comment: filled in"
      },
      "cancel": "Cancel",
      "confirm": "Confirm submit",
      "working": "Submitting…"
    },
    "noScoringNeeded": {
      "title": "No scoring needed for this work",
      "body": "This work's team is no longer part of the competition, so your score will not be counted and you do not need to score it. Contact the organizer if you have questions."
    }
  }
}
